export const CANCER_TYPE_PARAM_ID = 20;
export const CANCER_SUBTYPE_PARAM_ID = 21;
